export const analytics = {
  projectProgress: "Progresso do projeto",
  hi: "Oi",
  realProgress: "Progresso real",
  welcomeBack: "Bem-vindo",
  moduleStatistics: "Estatísticas do módulo",
  onTime: "No Tempo",
  overdue: "Atrasado",
  constructionPercentage: "Porcentagem de construção",
  completed: "Concluído",
  thisWeek: "Esta semana",
  workForce: "Força de trabalho",
  hours: "Horas",
  completedTasks: "Tarefas concluídas",
  analytics: "Analítica",
  addWidgets: "Adicione seus widgets para exibir",
  projectStatistics: "Estatísticas do projeto",
  rfis: "RFIs",
tasks: "Tarefas",
submittals: "Submissões",
delayed: "Atrasado",
closed: "Fechado",
pending: "Pendente",
onProgress: "Em Progresso",
done: "Concluído",
selectWidget: "Selecione o widget de sua escolha",
widgetDisplayed: "O widget selecionado será exibido em seu painel"

};
